export interface VariantClass {
    id: number;
    description: string;
    value: string;
}
